import { RouteItemEnum } from '@shared/enums';

export const MEASUREMENT_STUDIO_SETTINGS_ROUTE_ITEMS = [
  RouteItemEnum.AccountEngagement,
  RouteItemEnum.CampaignScoring,
];
